export default __webpack_public_path__ + "static/media/logo_payoff_pos.d41097e7.svg";